module.exports = __webpack_public_path__ + "static/media/customer_booking_app_bg.7b86c6ec.svg";